import { Filter, GradeGuide } from "@hatch-digital-nl/bravilor-storybook";
import { JSX } from "react";
import { useFilters } from "../hooks/useFilters";
import { useRefurbishedPage } from "../hooks/useRefurbishedPage";
import Skeleton from "react-loading-skeleton";
import { useStringTranslation } from "../../../common/hooks/useStringTranslation";

export const Filters = (): JSX.Element => {
    const { filterGroups, isLoading } = useFilters();
    const { handleSetFilters, refurbishedState } = useRefurbishedPage();
    const { t, isLoading: translationsIsLoading } = useStringTranslation();

    const gradeGuideText = t("grade-guide");
    const isContentLoading = isLoading || translationsIsLoading;

    if (isContentLoading) {
        return (
            <div className="p-refurbished__filters-row">
                <Skeleton
                    containerClassName="p-refurbished__filters p-refurbished__filters--skeleton"
                    style={{
                        maxWidth: "18rem",
                        width: "100%",
                        height: "3.5rem",
                    }}
                    borderRadius={"0.8rem"}
                />
                <GradeGuide text={gradeGuideText} isLoading />
            </div>
        );
    }

    return (
        <div className="p-refurbished__filters-row">
            <div className="p-refurbished__filters">
                <Filter
                    filterGroups={filterGroups}
                    onFilterApply={handleSetFilters}
                    initialSelectedValues={refurbishedState.selectedFilters}
                    showResultsLabel={t("show-results")}
                    clearAllLabel={t("clear-all")}
                />
            </div>
            <GradeGuide
                className="p-refurbished__grade-guide"
                text={gradeGuideText}
            />
        </div>
    );
};
